query marketHashesExport {
    marketHashesExport
}
